import { Flex } from "@chakra-ui/react";
import { NavLink, NavLinkProps, useMatch } from "react-router-dom";


function SidebarLink({
  children,
  to,
  ...rest
}: NavLinkProps) {
  const isActive = useMatch(to.toString());

  if (isActive) {
    return (
      <Flex
        bg="white"
        rounded="lg"
        px="6px"
        py="8px"
        boxShadow="sm"
        color="brand.600"
        fontWeight="600"
        fontSize="14px"
        lineHeight="21px"
      >
        <NavLink to={to} {...rest} style={{ width: "100%", position: "relative", left: '23px' }}>
          <Flex align="center" gap="2">
            <>
              {children}
            </>
          </Flex>
        </NavLink>
      </Flex>
    );
  }
  return (
    <Flex
      px="6px"
      py="8px"
      color="gray.500"
      fontWeight="600"
      fontSize="14px"
      lineHeight="21px"
    >
      <NavLink to={to} {...rest} style={{ width: "100%", position: "relative", left: '23px' }}>
        <Flex align="center" gap="2">
          <>
            {children}
          </>
        </Flex>
      </NavLink>
    </Flex>
  );
}

export default SidebarLink;
